// extracted by mini-css-extract-plugin
export var label = "_ec-2";
export var slideContainer = "_ec-0";
export var slider = "_ec-1";